import { z } from 'zod/v4';
import { OrganizationIdentifierScheme } from '../customers/types.js';
export var EInvoiceType;
(function (EInvoiceType) {
    EInvoiceType["Invoice"] = "INVOICE";
    EInvoiceType["Reminder"] = "REMINDER";
    EInvoiceType["Creditnote"] = "CREDITNOTE";
})(EInvoiceType || (EInvoiceType = {}));
export const SproomSenderSchema = z.object({
    name: z.string(),
    organizationIdentifier: z.object({
        scheme: z.union([
            z.literal(OrganizationIdentifierScheme.DK_CVR),
            z.literal(OrganizationIdentifierScheme.GLN),
        ]),
        value: z.string(),
    }),
    childCompanyId: z.string(),
    companyId: z.string(),
    cvr: z.string(),
});
export const SproomReceiverSchema = z.object({
    name: z.string(),
    cvr: z.string(),
    organizationIdentifier: z.object({
        scheme: z.enum(OrganizationIdentifierScheme).exclude(['DK_CPR']),
        value: z.string(),
    }),
});
//# sourceMappingURL=index.js.map